import Vue from 'vue';

export function getNestedValue(obj, keyPath, fallback = undefined) {
    return keyPath.split('.').reduce((acc, key) => {
      if (acc == null) return undefined;
      const prop = isNaN(key) ? key : Number(key);
      return acc[prop];
    }, obj) ?? fallback;
  }

export function setNestedValue(obj, keyPath, value) {
  if (typeof keyPath !== 'string') {
    throw new TypeError(`Invalid keyPath: expected a string but got ${typeof keyPath}`);
  }

  const keys = keyPath.split('.');
  let current = obj;

  for (let i = 0; i < keys.length; i++) {
    const isLast = i === keys.length - 1;
    const key = isNaN(keys[i]) ? keys[i] : Number(keys[i]);

    if (isLast) {
      // Use Vue.set for reactivity
      if (Array.isArray(current)) {
        Vue.set(current, key, value);
      } else {
        Vue.set(current, key, value);
      }
      // console.log(`Set value at path "${keyPath}" to`, value);
    } else {
      if (current[key] == null) {
        current[key] = isNaN(keys[i + 1]) ? {} : [];
        Vue.set(current, key, current[key]);
      }
      current = current[key];
    }
  }

  return obj;
}

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
  str = str.toLowerCase(); // convert string to lowercase
  str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
          .replace(/\s+/g, '-') // replace spaces with hyphens
          .replace(/-+/g, '-'); // remove consecutive hyphens
  return str;
}